import { Injectable } from '@angular/core';
import { Capacitor } from '@capacitor/core';
import { environment } from '../../environments/environment';

const isEnabled = () => environment.enableLogger && Capacitor.isNativePlatform();

class ScopedLogger {
  private prefix: string;

  constructor(name: string) {
    this.prefix = `[${name}]`;
  }

  log(...args: unknown[]) {
    if (isEnabled()) {
      console.log(this.prefix, ...args);
    }
  }

  warn(...args: unknown[]) {
    if (isEnabled()) {
      console.warn(this.prefix, ...args);
    }
  }

  error(...args: unknown[]) {
    if (isEnabled()) {
      console.error(this.prefix, ...args);
    }
  }
}

@Injectable({
  providedIn: 'root',
})
export class LoggerService {
  for(name: string): ScopedLogger {
    return new ScopedLogger(name);
  }
}

export const logger = new LoggerService();
